import React from 'react';

import StorageImage from 'rebook/apps/utils/components/StorageImage';


const ResizedImage = (props) => (
  <StorageImage type="resized" {...props} />
);

export default ResizedImage;
